module.exports = __webpack_public_path__ + "img/promo-coin.283d96a0.png";